import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard, PendingChangesGuard, PrepareGuard } from 'app/core/core.module';
import { PurchaseOrderSearchComponent } from './purchase-order-search/purchase-order-search.component';
import { PurchaseOrderDetailComponent } from './purchase-order-detail/purchase-order-detail.component';
import { PurchaseOrderReceivingsComponent } from './purchase-order-receivings/purchase-order-receivings.component';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { PurchaseOrderHistoryComponent } from './purchase-order-history/purchase-order-history.component';
import { EmailSearchComponent } from 'app/orders/email-search/email-search.component';
import { PurchaseOrderInvoiceDialogComponent } from './purchase-order-invoice-dialog/purchase-order-invoice-dialog.component';
import { PurchaseOrderBillingComponent } from './purchase-order-billing/purchase-order-billing.component';
import { VendorPickupDialogComponent } from './vendor-pickup-dialog/vendor-pickup-dialog.component';
import { VendorPickupOverviewComponent } from './vendor-pickup-overview/vendor-pickup-overview.component';
import { PickupLinesSelectDialogComponent } from './pickup-lines-select-dialog/pickup-lines-select-dialog.component';
import { AssemblyBomSelectDialogComponent } from './assembly-bom-select-dialog/assembly-bom-select-dialog.component';
import { PoMiscLineDialogComponent } from './po-misc-line-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'purchase-orders',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'search', pathMatch: 'full' },
                    { path: 'search', component: PurchaseOrderSearchComponent, data: { title: 'Purchase Orders' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'receivings', component: PurchaseOrderReceivingsComponent, data: { title: 'Receivings' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'billing', component: PurchaseOrderBillingComponent, data: { title: 'Billing' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'email', component: EmailSearchComponent, data: { title: 'Email' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'history', component: PurchaseOrderHistoryComponent, data: { title: 'History' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'vendor-pickup', component: VendorPickupOverviewComponent, data: { title: 'Vendor PickUp Overview' }, canActivate: [AuthGuard, PrepareGuard] },
                    {
                        path: ':id',
                        component: PurchaseOrderDetailComponent,
                        data: { title: 'Detail' },
                        canActivate: [AuthGuard, PrepareGuard],
                        canDeactivate: [PendingChangesGuard],
                    },
                ],
            },
        ]),
    ],
    declarations: [
        PurchaseOrderSearchComponent,
        PurchaseOrderDetailComponent,
        PurchaseOrderReceivingsComponent,
        PurchaseOrderHistoryComponent,
        PurchaseOrderInvoiceDialogComponent,
        PurchaseOrderBillingComponent,
        VendorPickupDialogComponent,
        VendorPickupOverviewComponent,
        PickupLinesSelectDialogComponent,
        AssemblyBomSelectDialogComponent,
        PoMiscLineDialogComponent,
    ],
})
export class PurchaseOrdersModule {}
